export default {
    url: '/training?tab',
    template: `
        <courses-courses-steps-version-training-skeleton ng-if="!vm.loaded" settings="vm.settings" />
        <courses-courses-edit-version-edit-training
            ng-if="vm.loaded"
            course-version="vm.courseVersion"
            forms="vm.forms"
            survey-forms="vm.surveyForms"
            feedback-forms="vm.feedbackForms"
            learndash-courses="vm.learndashCourses"
            scorm-courses="vm.scormCourses"
            can-manage-course="vm.canManageCourse"
            course="vm.course"
            form="vm.form"
            company="vm.company"
            loaded="vm.loaded"
            active-tab="vm.activeTab"
            settings="vm.settings"
        />`,
    controller (FormResource, FORMS_TYPE_ENUM, PrivilegeService, $scope, LearndashResource, course, CourseService,
        TokenService, ScormCloudResource, CourseVersionService, FormFactory, CompanyResource, $stateParams, $translate) {
        this.course = course;
        this.forms = [];
        this.courseVersion = $scope.$parent.vm.courseVersion;
        this.activeTab = $stateParams.tab;
        this.TokenService = TokenService;
        this.PrivilegeService = PrivilegeService;
        this.settings = {
            activeTabId: 'activities',
            tabs: [
                {
                    id: 'activities',
                    title: $translate.instant('version.Activities'),
                    isEnabled: true
                },
                {
                    id: 'settings',
                    title: $translate.instant('general.Settings'),
                    isEnabled: true
                },
                {
                    id: 'licence',
                    title: $translate.instant('licence.Licence points'),
                    isEnabled: this.TokenService.isLicencePointsModuleEnabled() && this.PrivilegeService.canManageLicencePoints()
                },
                {
                    id: 'skills',
                    title: $translate.instant('skill.Skills'),
                    isEnabled: this.TokenService.isSkillsModuleEnabled() && this.PrivilegeService.canManageSkills()
                }
            ]
        };

        // update courseVersion from parent component
        $scope.$watch(() => $scope.$parent.vm.courseVersion, (courseVersion) => {
            if (courseVersion) {
                this.courseVersion = courseVersion;
            }
        });
        CourseVersionService.nestCompositeModels(this.courseVersion);

        this.form = FormFactory.createFromResource(this.courseVersion);
        this.canManageCourse = CourseService.canManageCourse(course);

        this.scormCourses = [];

        if (TokenService.isScormCloudEnabled()) {
            ScormCloudResource.query().$promise.then((response) => {
                this.scormCourses = response;
            });
        }

        this.formsLoaded = false;
        this.surveyFormsLoaded = false;
        this.feedbackFormsLoaded = false;
        this.learndashCoursesLoaded = false;

        // Fetch Forms Asynchronously
        function fetchForms (type) {
            return FormResource.query({
                pageSize: 0,
                expand: 'activeI18n',
                type,
                'privileges[]': PrivilegeService.getCourseVersionFormViewPrivileges()
            }).$promise;
        }

        fetchForms(FORMS_TYPE_ENUM.KEYS.CERTIFICATION).then(response => {
            this.forms = response;
            this.formsLoaded = true;
            this.checkIfLoaded();
        });
        fetchForms(FORMS_TYPE_ENUM.KEYS.SURVEY).then(response => {
            this.surveyForms = response;
            this.surveyFormsLoaded = true;
            this.checkIfLoaded();
        });
        fetchForms(FORMS_TYPE_ENUM.KEYS.CERTIFICATION_FEEDBACK).then(response => {
            this.feedbackForms = response;
            this.feedbackFormsLoaded = true;
            this.checkIfLoaded();
        });

        CompanyResource.publicView({ id: TokenService.getCompanyId() }).$promise.then(company => {
            this.company = company;
            this.companyLoaded = true;
        });

        // Fetch Learndash Courses
        this.loaded = false;
        const params = { lang: TokenService.getCompanyLanguage(true) };
        LearndashResource.getCompanyCourses(params).$promise.then(response => {
            this.learndashCourses = response;
            this.learndashCoursesLoaded = true;
            this.checkIfLoaded();
        });

        this.checkIfLoaded = () => {
            this.loaded = this.formsLoaded && this.surveyFormsLoaded && this.feedbackFormsLoaded && this.learndashCoursesLoaded && this.companyLoaded;
        };
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/version/edit/training/index.js